import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

// Canlı Google Reviews widget'ı (Elfsight). Yükleyici script index.html'de
// tanımlı (<script src="https://elfsightcdn.com/platform.js" async>).
// Widget kendi içinde otomatik olarak Google Business profiliyle senkronize
// oluyor - manuel güncelleme gerekmiyor. data-elfsight-app-lazy sayesinde
// sadece bu bölüm görünüme girdiğinde yükleniyor (performans için iyi).
//
// Widget kendi şablonunda sabit İngilizce bir alt başlık ("What Our
// Customers Say") gösteriyor - bunu widget'ın kendi ayarlarından
// değiştiremediğimiz için (üçüncü parti script), yüklendikten sonra DOM'da
// arayıp gizliyoruz. Widget lazy-load olduğundan MutationObserver ile
// enjekte edilmesini bekliyoruz.
const HIDDEN_WIDGET_TEXT = "What Our Customers Say";

const GoogleReviewsWidget: React.FC = () => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const hideMatchingText = () => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT);
      let node = walker.currentNode as HTMLElement | null;
      while (node) {
        if (
          node.children.length === 0 &&
          node.textContent?.trim() === HIDDEN_WIDGET_TEXT &&
          (node as HTMLElement).style.display !== "none"
        ) {
          (node as HTMLElement).style.display = "none";
        }
        node = walker.nextNode() as HTMLElement | null;
      }
    };

    const observer = new MutationObserver(hideMatchingText);
    observer.observe(container, { childList: true, subtree: true });
    hideMatchingText();

    return () => observer.disconnect();
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-6 py-20 bg-white">
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-yellow-600 font-semibold text-sm uppercase tracking-widest text-center mb-3"
      >
        {t("reviews.eyebrow")}
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="text-4xl font-bold mb-12 text-center text-black"
      >
        {t("reviews.title")}
      </motion.h2>

      <div ref={containerRef}>
        <div className="elfsight-app-dbc0a211-5426-4df1-b0c8-25668a33da59" data-elfsight-app-lazy />
      </div>
    </section>
  );
};

export default GoogleReviewsWidget;
